module.exports = __webpack_public_path__ + "a8cf96b82d5b85b7d4a08033292f6ccd.MP3";